import { useQueryClient } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import { CustomerAgreementDeactivationImpactQueryKey } from '../queryKeys';
import { DeactivationImpact } from '../types';

export type CheckDeactivationImpact = (id: number) => Promise<DeactivationImpact>;

export function useCheckDeactivationImpact(): CheckDeactivationImpact {
    const queryClient = useQueryClient();

    return function checkDeactivationImpact(id: number) {
        return queryClient.fetchQuery(
            [CustomerAgreementDeactivationImpactQueryKey, id],
            () => CustomerAgreementsApi.getDeactivationImpact(id),
            { staleTime: 0 }
        );
    };
}
